var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"min-height":"100vh","flat":""}},[_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_c(_setup.Product),_c(_setup.Relrank)],1),_c('v-col',[_c(_setup.Timeline)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }